import { render, staticRenderFns } from "./CreateLocalContractStep.vue?vue&type=template&id=2844a955"
import script from "./CreateLocalContractStep.vue?vue&type=script&lang=js"
export * from "./CreateLocalContractStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports